/**
 * 竟品评价
 */
import React from "react";
import PropTypes from "prop-types";

const CommentsExt = ({ product }) => (
  <div className="comments-ext">
    <div className="comments-ext__title">
      房客们普遍觉得：<span className="text-orange">{product.extOverallRating}</span>
    </div>
    <div className="comments-ext__count">来自该房源其他平台上的{product.extCommentNumber}条评价</div>
    {product.extTagList ? (
      <ul className="comments-ext__list list-inline">
        {product.extTagList.map(item => (
          <li className="comments-ext__label">
            {item.tagName}({item.hit})
          </li>
        ))}
      </ul>
    ) : null}
  </div>
);

CommentsExt.propTypes = {
  product: PropTypes.object.isRequired,
};

export default CommentsExt;

require("./index.less");
require("./index.less");